export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9536.e61c1e81.jpg";